import { UserDTO } from './common/Dtos';
import React, { useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, Grid, TextField } from '@material-ui/core';
import { SDialogButton, SDialogTitle } from './common/BCommonComponents';

interface AggiungiCodiceFiscaleDialogProps {
	open: boolean;
	onClose: (userDTO?: UserDTO) => void;
	userDTO: UserDTO;
}

function AggiungiCodiceFiscaleDialog(props: AggiungiCodiceFiscaleDialogProps) {
	const {onClose, open} = props;
	const [codiceFiscale, setCodiceFiscale] = useState<string>();
	const [user, setUser] = useState<UserDTO>(props.userDTO);
	const [errorCodiceFiscale, setErrorCodiceFiscale] = useState<boolean>(false);

	useEffect(() => {
	}, [codiceFiscale]);

	useEffect(() => {
		setCodiceFiscale('');
		setUser(props.userDTO);
	}, [open]);

	const handleConferma = () => {
		const newUser: UserDTO = {
			...user,
			codiceFiscale: codiceFiscale ? codiceFiscale : ''
		}

		if (codiceFiscale && codiceFiscale !== '') {
			const regex = /^([A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1})$|([0-9]{11})$/;
			if (regex.test(codiceFiscale)) {
				onClose(newUser);
			} else {
				setErrorCodiceFiscale(true);
			}
		}

	};

	const handleCodiceFiscaleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		let cf = event.target.value;

		if (cf && cf !== '') {
			cf = cf.toUpperCase();
		}
		setCodiceFiscale(cf);
	};

	return (
		<Dialog
			disableBackdropClick
			open={open}>
			<SDialogTitle className="pb-0" id="simple-dialog-title">INSERISCI IL TUO CODICE FISCALE</SDialogTitle>
			<DialogContent>
				<Grid container spacing={0} className="w-100">
					<Grid item xs={12} className="px-2">
						<TextField
							className="w-100"
							id="codiceFiscale"
							label="Codice Fiscale"
							variant="outlined"
							value={codiceFiscale}
							onChange={handleCodiceFiscaleChange}
							error={errorCodiceFiscale}
							helperText={errorCodiceFiscale && "Codice Fiscale non valido"}
							InputLabelProps={{shrink: true}}
							inputProps={{style: {textTransform: "uppercase"}}}
							required={true}
						/>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions className="p-4">
				<SDialogButton className="float-right" onClick={handleConferma}>SALVA</SDialogButton>
			</DialogActions>
		</Dialog>
	);
}

export default AggiungiCodiceFiscaleDialog;
